module.exports = __webpack_public_path__ + "img/plant1.c87e7742.jpg";